<div class="body">

    <div class="afiliado" *ngIf="rol == 'ROLE_ADMINISTRADOR' || rol == 'ROLE_CONTABILIDAD' || rol == 'ROLE_ENCARGADO_CONTABILIDAD' || rol == 'ROLE_COORDINADOR'">

        <div class="container" style="height:100px"> </div>

        <div class="container" id="tabla" style="background-color: white; padding-top: 70px; max-width: 1340px; ;padding-bottom:50px">

            <div class="row">

                <div class="col-lg-6">
                    <h1> Agrupaciones de Pago </h1>
                </div>

                <div class="col-lg-3"> </div>

                <div class="col-lg-2">
                    <h3> Cantidad de Registros </h3>
                </div>

                <div class="col-lg-1">

                 
                    <select class="form-control" (change)="buscarOpcion()" [(ngModel)] = "config.itemsPerPage" #itemsPerPage="ngModel">
                        <option value = "5">5</option>
                        <option value = "10">10</option>
                        <option value = "20">20</option>
                        <option value = "30">30</option>
                        <option value = "50">50</option>
                    </select> </div>

            </div>
            <hr/> <br/>

            <div class="row">

                <div class="col-lg-1">
                    <h3> Estado: </h3>
                </div>

                <div class="col-lg-2">

                    <select class="form-control" [(ngModel)]="estado" (change)="loadData()">
                        
                        <option *ngFor = "let estado of estados" value = {{estado}}> {{estado}} </option>
                        
                    </select>

                </div>

            </div> <br/> <br/>

            <div class="table-responsive">

                <table class="table">

                    <thead style="background-color: #0f69b4;color:white;">

                        <tr>
                            <th scope="col"> N° </th>

                            <th scope="col"> Fecha Pago Estimada </th>

                            <th scope="col"> Usuario Agrupador </th>

                            <th scope="col"> Postulaciones </th>

                            <th scope="col"> total a Pagar </th>

                            <th scope="col"> Fecha Modificación </th>

                            <th scope="col"> Estado </th>

                            <th scope="col"> </th>

                            <th scope="col" *ngIf="rol == 'ROLE_ADMINISTRADOR'  && (estado == 'PAGADO')"> </th>

                            <th scope="col"> </th>

                            <th scope="col"> </th>

                            <th scope="col"> </th>

                            <th scope="col" *ngIf="estado != 'CREADO'"> </th>
                        </tr>

                    </thead>

                    <tbody>

                        <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let agrupacion of agrupaciones | paginate: config; let i = index">

                            <td> {{agrupacion.id}} </td>

                            <td> {{agrupacion.fechaPagoEstimada}} </td>

                            <td> {{agrupacion.nombreUsuarioAgrupa}} </td>

                            <td> {{agrupacion.postulaciones}} </td>

                            <td> {{agrupacion.totalPagar}} </td>

                            <td> {{agrupacion.fechaModificacion}} </td>

                            <td> {{agrupacion.estado}} </td>

                            <td>
                                <a style="cursor: pointer" (click)="obtenerExcel(agrupacion.id, agrupacion.estado)">
                                    <mat-icon> cloud_download</mat-icon>
                                </a>
                            </td>

                            <td *ngIf="rol == 'ROLE_ADMINISTRADOR' && (estado == 'PAGADO')">
                                <a style="cursor: pointer" (click)="reenviarPagosPS(agrupacion.id)">
                                    <mat-icon> bolt</mat-icon>
                                </a>
                            </td>


                            <td *ngIf="agrupacion.estado != 'PAGADO'"> <button class="btn btn-danger" (click)="eliminarAgrupacion(agrupacion.id)" style="width:120px"> 
                         
                                <i class = "fa fa-pen"> </i> Eliminar                         
                            </button> </td>

                            <td *ngIf="agrupacion.estado != 'CREADO'"> <button class="btn btn-success" (click)="pdfFirmado(agrupacion.id)" style="width:140px"> 
                         
                                <i class = "far fa-file-pdf"> </i> PDF firmado                         
                            </button> </td>

                          
                            <td> 
                                <button *ngIf = "agrupacion.estado == 'CREADO' && (rol == 'ROLE_ADMINISTRADOR' || rol == 'ROLE_CONTABILIDAD' || rol == 'ROLE_COORDINADOR'|| rol == 'ROLE_ENCARGADO_CONTABILIDAD')"  style = "width: 100px"
                                class = "btn btn-success" (click) = "openCodigoFirmaDialog(agrupacion.id)"> 
                                        
                                        <i class = "fa fa-pen"> </i> Firmar 
                                    
                                </button> 
                             
                                <button *ngIf = "agrupacion.estado == 'FIRMADO' && (rol == 'ROLE_ADMINISTRADOR' || rol == 'ROLE_COORDINADOR' || rol == 'ROLE_ENCARGADO_CONTABILIDAD' || rol == 'ROLE_CONTABILIDAD')"   style = "width: 100px"
                                [disabled]="agrupacion.idUsuarioFirmaDos>0" class = "btn btn-success" (click) = "openCodigoSegundaFirmaDialog(agrupacion.id)"> 

                                 
                                        <i class = "fa fa-pen"> </i> Firmar
                                </button>
                            </td>
                            <td>

                                <button *ngIf = "agrupacion.estado == 'FIRMADO'&& (rol == 'ROLE_ADMINISTRADOR' || rol == 'ROLE_COORDINADOR'|| rol == 'ROLE_CONTABILIDAD' || rol == 'ROLE_ENCARGADO_CONTABILIDAD')"   style = "width: 100px"
                                [disabled]="!(agrupacion.idUsuarioFirmaDos>0) || agrupacion.pendientePago==true " class = "btn btn-success" (click) = "onPagarClick(agrupacion.id)"> 
                                                 
                                        <i class = "fa fa-pen"> </i> Pagar
                                    
                                </button>

                            </td>
                        </tr>

                    </tbody>

                </table> <br/>

                <pagination-controls style="text-align: center" previousLabel="Anterior" nextLabel="Siguiente" (pageChange)="pageChanged($event)" autoHide="true"> </pagination-controls>
                 
            </div>

        </div>

        <div class="container" style="height:100px"> </div>

    </div>

</div>